import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import enCommon from "../locales/en/common.json";
import deCommon from "../locales/de/common.json";
import zhCommon from "../locales/zh/common.json";

const STORAGE_KEY = "df_language";

const resources = {
  en: { common: enCommon },
  de: { common: deCommon },
  zh: { common: zhCommon },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: ["en", "de", "zh"],
    defaultNS: "common",
    ns: ["common"],
    keySeparator: false,
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: STORAGE_KEY,
    },
    returnEmptyString: false,
  });

i18n.on("initialized", () => {
  const initialLanguage = i18n.resolvedLanguage || i18n.language || "en";
  if (typeof document !== "undefined" && document.documentElement) {
    document.documentElement.lang = initialLanguage;
  }
});

i18n.on("languageChanged", (lng) => {
  if (typeof document !== "undefined" && document.documentElement) {
    document.documentElement.lang = lng || "en";
  }
});

export default i18n;
